import { LaneType } from 'common-types';

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use TimeRangeType from application-types instead.
 */
export type TimeRangeType = {
  _id?: LaneType.UUID;
  startTime: string;
  endTime: string;
};

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use DEFAULT_START_TIME from application-types instead.
 */
export const DEFAULT_START_TIME = '9:00 AM';
/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use DEFAULT_END_TIME from application-types instead.
 */
export const DEFAULT_END_TIME = '5:00 PM';
/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use START_OF_DAY from application-types instead.
 */
export const START_OF_DAY = '12:00 AM';
/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use END_OF_DAY from application-types instead.
 */
export const END_OF_DAY = '11:59 PM';
